import { render, staticRenderFns } from "./PainelAdequacaoLGPD.vue?vue&type=template&id=6d707526"
import script from "./PainelAdequacaoLGPD.vue?vue&type=script&lang=js"
export * from "./PainelAdequacaoLGPD.vue?vue&type=script&lang=js"
import style0 from "./PainelAdequacaoLGPD.vue?vue&type=style&index=0&id=6d707526&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports